export class Base64Utils {

    static getImgMimeType( data: string ){
    if(data.charAt(0)=='/'){
      return "image/jpeg";
    } else if(data.charAt(0)=='R'){
      return "image/gif";
    } else if(data.charAt(0)=='i'){
      return "image/png";
    }
    return null;
  }

}
